import { createRouter, createWebHistory, createMemoryHistory } from 'vue-router'
import { useAuthStore } from '@/stores/auth'
import { useSessionStore } from '@/stores/session'
import { useNotificationStore } from '@/stores/notification'
import { requireAuthenticatedUser } from '@/router/guards'
import { isNetworkOrTimeoutError } from '@/services/api/base'
import { baseRoute, notFoundRoute, catchAllRoute } from '@/modules/core/core.routes'
import { authRoutes, authChildRoutes } from '@/modules/auth/auth.routes'
import { productRoutes } from '@/modules/products/products.routes'
import { orderRoutes } from '@/modules/orders/orders.routes'
import { customerRoutes } from '@/modules/customers/customers.routes'
import { userRoutes } from '@/modules/users/users.routes'
import { validatorRoutes } from '@/modules/validators/validators.routes'
import { passRoutes } from '@/modules/passes/passes.routes'
import { paymentRoutes } from '@/modules/payments/payments.routes'
import { refundRoutes } from '@/modules/refunds/refunds.routes'
import { scanRoutes } from '@/modules/scans/scans.routes'
import { qrCodeRoutes } from '@/modules/qr-codes/qr-codes.routes'
import { reportRoutes } from '@/modules/reports/reports.routes'
import { settingsRoutes } from '@/modules/settings/settings.routes'
import { decryptRoutes } from '@/modules/decrypt/decrypt.routes'
import { cardRoutes } from '@/modules/cards/cards.routes'
import { printedTicketRoutes } from '@/modules/printed-tickets/printed-tickets.routes'
import { couponRoutes } from '@/modules/coupons/coupons.routes'
import { posRoutes } from '@/modules/pos/pos.routes'

const appChildRoutes = [
  ...productRoutes,
  {
    path: '',
    component: () => null,
    beforeEnter: requireAuthenticatedUser
  },
  ...orderRoutes,
  ...customerRoutes,
  ...cardRoutes,
  ...printedTicketRoutes,
  ...decryptRoutes,
  ...passRoutes,
  ...paymentRoutes,
  ...refundRoutes,
  ...scanRoutes,
  ...userRoutes,
  ...reportRoutes,
  ...posRoutes,
  ...settingsRoutes,
  ...authChildRoutes,
  ...couponRoutes,
  ...qrCodeRoutes,
  ...validatorRoutes
]

const router = createRouter({
  history: import.meta.env.MODE === 'test' ? createMemoryHistory() : createWebHistory(import.meta.env.BASE_URL),
  routes: [
    ...authRoutes,
    {
      ...baseRoute,
      children: appChildRoutes
    },
    notFoundRoute,
    catchAllRoute
  ]
})

router.beforeEach(async (_to, _from, next) => {
  const authStore = useAuthStore()
  const sessionStore = useSessionStore()
  authStore.loadTokenFromCookie()
  const pingResult = await sessionStore.ping()

  if (!isNetworkOrTimeoutError(pingResult.errorCode)) {
    authStore.isAuthenticated = !!pingResult.success
  }

  next()
})

router.afterEach(() => {
  const notificationStore = useNotificationStore()
  notificationStore.clearDisplayed()
})

export default router
